import { Observable } from 'rxjs';

import { CoverageAreaType } from '@shure/shared/angular/data-access/system-api/models';

import { CoverageAudioCoverageArea, CoverageAreaRect } from './models';

export type CoverageAreaEnableConfigs = { coverageAreaId: string; rect: CoverageAreaRect };

export abstract class CoverageAudioCoverageAreaApiService {
	public abstract getCoverageArea$(coverageAreaId: string): Observable<CoverageAudioCoverageArea>;

	public abstract addCoverageAreas(
		type: CoverageAreaType,
		coverageAreaEnableConfigs: CoverageAreaEnableConfigs[]
	): Observable<void>;
	public abstract removeCoverageAreas(coverageAreaIds: string[]): Observable<void>;
	public abstract setCoverageAreasMute(coverageAreaIds: string[], muted: boolean): Observable<void>;
	public abstract setCoverageAreaGain(coverageAreaId: string, gain: number): Observable<void>;
	public abstract setCoverageAreaRect(coverageAreaId: string, area: CoverageAreaRect): Observable<void>;
	public abstract resetCoverageAreas(deviceId: string): Observable<void>;
	public abstract resetChannels(deviceId: string): Observable<void>;
}
